
import { success } from "toastr";
import * as types from "./actionTypes";

const initialState = {
    loading: false,
    error: null,
    success: false,
    payslipdetails: '',
    wageregister: '',
    bankStatementDetails: [],
    sectionWageList: [],
    ctcreport: [],
    monthlyESIList: [],
    monthlyPFList: [],
    payregsummaryList: [],
    reopenPayment: [],
    payEmpReportList: [],
};

const PayrollReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_EMPLOYEE_PAYSLIPS:
            return { ...state, loading: true, success: false };
        case types.FETCH_EMPLOYEE_PAYSLIPS_SUCCESS:
            return { ...state, loading: false, success: true, payslipdetails: action.payload, };
        case types.FETCH_EMPLOYEE_PAYSLIPS_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, };
        case types.RESET_SAVE_STATUS:
            return {
                ...state,
                success: false,
                payslipdetails: [],
                wageregister: [],
            };

        case types.FETCH_EMPLOYEE_WAGEREGISTER:
            return { ...state, loading: true, success: false };
        case types.FETCH_EMPLOYEE_WAGEREGISTER_SUCCESS:
            return { ...state, loading: false, success: true, wageregister: action.payload, };
        case types.FETCH_EMPLOYEE_WAGEREGISTER_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, };

        case types.FETCH_BANKSTATEMENT_DETAILS:
            return { ...state, loading: true, success: false };
        case types.FETCH_BANKSTATEMENT_SUCCESS:
            return { ...state, loading: false, success: true, bankStatementDetails: action.payload };
        case types.FETCH_BANKSTATEMENT_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, bankStatementDetails: [] };
        case types.CLEAR_BANKSTATEMENT_DETAILS:
            return { ...state, bankStatementDetails: [] };

        case types.FETCH_SECTION_WAGE_LIST:
            return { ...state, loading: true, success: false };
        case types.FETCH_SECTION_WAGE_SUCCESS:
            return { ...state, loading: false, success: true, sectionWageList: action.payload };
        case types.FETCH_SECTION_WAGE_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, sectionWageList: [] };
        case types.CLEAR_SECTION_WAGE_LIST:
            return { ...state, sectionWageList: [], };

        case types.FETCH_EMPLOYEE_CTCT_LIST:
            return { ...state, loading: true, success: false };
        case types.FETCH_EMPLOYEE_CTCT_LIST_SUCCESS:
            return { ...state, loading: false, success: true, ctcreport: action.payload };
        case types.FETCH_EMPLOYEE_CTCT_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, ctcreport: [] };

        case types.FETCH_MONTHLY_ESI_LIST:
            return { ...state, loading: true, success: false };
        case types.FETCH_MONTHLY_ESI_LIST_SUCCESS:
            return { ...state, loading: false, success: true, monthlyESIList: action.payload };
        case types.FETCH_MONTHLY_ESI_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, monthlyESIList: [] };
        case types.CLEAR_MONTHLY_ESI_LIST:
            return { ...state, monthlyESIList: [], };

        case types.FETCH_MONTHLY_PF_LIST:
            return { ...state, loading: true, success: false };
        case types.FETCH_MONTHLY_PF_LIST_SUCCESS:
            return { ...state, loading: false, success: true, monthlyPFList: action.payload };
        case types.FETCH_MONTHLY_PF_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, monthlyPFList: [] };
        case types.CLEAR_MONTHLY_PF_LIST:
            return { ...state, monthlyPFList: [], };

        case types.FETCH_PAYREG_SUMMARY_LIST:
            return { ...state, loading: true, success: false };
        case types.FETCH_PAYREG_SUMMARY_LIST_SUCCESS:
            return { ...state, loading: false, success: true, payregsummaryList: action.payload };
        case types.FETCH_PAYREG_SUMMARY_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, payregsummaryList: [] };
        case types.CLEAR_PAYREG_SUMMARY_LIST:
            return { ...state, payregsummaryList: [], };

        case types.FETCH_GETPAY_EMPLOYEE_REPORT_LIST:
            return { ...state, loading: true, success: false };
        case types.FETCH_GETPAY_EMPLOYEE_REPORT_LIST_SUCCESS:
            return { ...state, loading: false, success: true, payEmpReportList: action.payload };
        case types.FETCH_GETPAY_EMPLOYEE_REPORT_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload, success: false, payEmpReportList: [] };
        case types.CLEAR_GETPAY_EMPLOYEE_REPORT_LIST:
            return { ...state, payEmpReportList: [], };

        case "CLEAR_PAYSLIP_ERROR":
            return {
                ...state,
                error: null,
                successdata: [],
                payslipdetails: [],
                wageregister: [],
                bankStatementDetails: [],
                sectionWageList: [],
                ctcreport: [],
                monthlyESIList: [],
                monthlyPFList: [],
                payregsummaryList: [],
                reopenPayment: [],
                payEmpReportList: [],
            };

        default:
            return state;
    }
}

export default PayrollReportsReducer;